import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	archived: {
		id: 'project-template-select-v2.utils.templates.product-discovery.archived',
		defaultMessage: 'Archived',
		description: 'A work flow',
	},
	done: {
		id: 'project-template-select-v2.utils.templates.product-discovery.done',
		defaultMessage: 'Done',
		description: 'A work flow',
	},
	idea: {
		id: 'project-template-select-v2.utils.templates.product-discovery.idea',
		defaultMessage: 'Idea',
		description: 'An issue type',
	},
	delivery: {
		id: 'project-template-select-v2.utils.templates.product-discovery.delivery',
		defaultMessage: 'Delivery',
		description: 'A work flow',
	},
	discovery: {
		id: 'project-template-select-v2.utils.templates.product-discovery.discovery',
		defaultMessage: 'Discovery',
		description: 'A work flow',
	},
	impact: {
		id: 'project-template-select-v2.utils.templates.product-discovery.impact',
		defaultMessage: 'Impact',
		description: 'A work flow',
	},
	parkingLot: {
		id: 'project-template-select-v2.utils.templates.product-discovery.parking-lot',
		defaultMessage: 'Parking lot',
		description: 'A work flow',
	},
	readyForDelivery: {
		id: 'project-template-select-v2.utils.templates.product-discovery.ready-for-delivery',
		defaultMessage: 'Ready for delivery',
		description: 'A work flow',
	},
});
